// EXPIRY BREAKEVEN DISTANCES from the current spot (display only). An iron condor / strangle is profitable AT EXPIRY
// between its lower and upper breakeven; these say how far the underlying can move before reaching one. They are NOT
// protection, stop-loss or guaranteed-safety percentages: before expiry the position can lose inside the range.
//
//   downside % = (spot − lower BE) / spot × 100      upside % = (upper BE − spot) / spot × 100
//
// A negative distance means the spot is already beyond that breakeven. No spot -> no distance (never estimated).

export const BE_DISTANCE_NOTE = "Distance from the current spot to each EXPIRY breakeven - not a protection, stop-loss or guarantee: the position can lose before expiry inside this range.";

const num = (v) => (v === null || v === undefined || v === "" || Number.isNaN(Number(v)) ? null : Number(v));

/** {down, up} in % (null where an input is missing). */
export function beDistances(spot, lower, upper) {
  const s = num(spot), lo = num(lower), hi = num(upper);
  if (!(s > 0)) return { down: null, up: null };
  return { down: lo == null ? null : ((s - lo) / s) * 100, up: hi == null ? null : ((hi - s) / s) * 100 };
}

const one = (v, dir) => (v == null ? null : v < 0 ? `${dir} ${Math.abs(v).toFixed(2)}% beyond` : `${dir} ${v.toFixed(2)}%`);

/** "↓ 2.71% · ↑ 2.43%" (or "↓ 0.41% beyond"), null when nothing can be computed. */
export function beDistanceText(spot, lower, upper) {
  const { down, up } = beDistances(spot, lower, upper);
  const parts = [one(down, "↓"), one(up, "↑")].filter(Boolean);
  return parts.length ? parts.join(" · ") : null;
}

/** Tone: red when the spot is already beyond a breakeven. */
export const beDistanceBeyond = (spot, lower, upper) => {
  const { down, up } = beDistances(spot, lower, upper);
  return (down != null && down < 0) || (up != null && up < 0);
};
